<ng-container
  *ngIf="{
    items: items$ | async,
  } as content"
>
  <div #videoContainer class="container-video-banners">
    <div class="video-carrossel">
      <div
        class="js-video-item video-item"
        [ngClass]="{ 'is-active': i === 0 }"
        [attr.data-index]="i"
        *ngFor="let banner of content.items; let i = index"
      >
        <div class="container-text">
          <div class="container">
            <div class="container-text-inner">
              <div class="span line-1" [innerHTML]="banner.text?.line1"></div>
              <div class="span line-2" [innerHTML]="banner.text?.line2"></div>

              @if (banner?.action?.label && banner?.action?.url) {
                <cx-generic-link
                  class="banner-link"
                  [url]="banner.action?.url!"
                  [target]="banner.action?.isExternal ? '_blank' : '_self'"
                  [ariaLabel]="banner.action?.label"
                  [attr.title]="banner.action?.label"
                >
                  <span [innerHTML]="banner.action?.label"></span>
                  <span class="icon material-symbols-outlined d-flex"> arrow_forward_ios </span>
                </cx-generic-link>
              }
            </div>
          </div>
        </div>

        <video #video playsinline autoplay loop muted poster="{{ banner.banner.src }}" (canplay)="onCanPlay(video)">
          <source src="{{ banner?.video?.src }}" type="video/mp4" />
          Seu navegador não suporta o elemento de vídeo.
        </video>
      </div>

      @if (content.items?.length && content.items?.length! > 1) {
        <div class="container" *ngIf="content.items?.length">
          <div class="container-dots">
            <div class="dots">
              <div
                class="js-dot dot"
                [ngClass]="{ 'is-active': i === 0 }"
                [attr.data-index]="i"
                *ngFor="let banner of content.items; let i = index"
              >
                <button type="button" (click)="playByIndex(i)" [attr.aria-hidden]="true"></button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
